<template>
  <div class="ui-list field">
    <label
      v-if="label"
      class="mb-2 label no-select"
    >
      <h3>{{ label }}</h3>
    </label>
    <p
      v-if="hasHelpText"
      class="help-text"
      v-html="finalHelpText"
    ></p>
    <ListItem
      :key="childListKey"
      v-model="model"
      :level="1"
      :name="name"
      :item-being-edited="itemBeingEdited"
      :fields="fields"
      :min-items="minItems"
      :max-items="maxItems"
      :max-levels="maxLevels"
      :item-label="itemLabel"
      :is-disabled="isDisabled"
      :is-sortable="isSortable"
      @edit-item="setEditedItem"
    />
    <button
      class="btn btn-white btn-icon"
      :disabled="isDisabled || (maxItems && model.length >= maxItems)"
      @click="addListItem()"
    >
      <span
        v-show="maxItems && model.length >= maxItems"
        class="slb-tooltip"
      >
        O número máximo de itens é {{ maxItems }}.
      </span>
      <IconPlus size="xs" />
      <span>{{ addItemLabel }}</span>
    </button>
  </div>
</template>

<script>
import ListItem from '@/components/ListItem.vue';
import IconPlus from '@/components/icons/IconPlus.vue';
import uniqueId from '@/helpers/uniqueId';
import commonProperties from './common-properties';

export default {
  name: 'List',
  components: {
    ListItem,
    IconPlus,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    maxLevels: {
      type: Number,
      default: 1,
    },
    isSortable: {
      type: Boolean,
      default: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    minItems: {
      type: Number,
      default: null,
    },
    maxItems: {
      type: Number,
      default: undefined,
    },
    label: {
      type: String,
      default: '',
    },
    itemLabel: {
      type: [String, Function],
      default: 'Item nº {index}',
    },
    addItemLabel: {
      type: String,
      default: 'Adicionar',
    },
  },
  data() {
    return {
      itemBeingEdited: '',
    };
  },
  computed: {
    childListKey() {
      return this.model && this.model.reduce((key, item) => key + item.id, '');
    },
  },
  created() {
    // Add an id field if the item of the array doesn't have it
    this.model = this.model.map((item) => ({
      id: uniqueId(),
      ...item,
    }));
  },
  methods: {
    setEditedItem(idx) {
      this.$store.dispatch('setCurrentEditableItem', idx);
      this.itemBeingEdited = idx;
    },
    addListItem() {
      const id = uniqueId();
      const newItem = {
        id,
      };

      this.fields.forEach((field) => {
        newItem[field.name] = field.default;
      });

      if (this.maxLevels > 1) {
        newItem[this.name] = [];
      }

      this.model.push(newItem);

      if (
        !!this.$store.getters.containerId &&
        !this.$store.getters.activeGlobalData &&
        !this.$store.getters.activeExternalGlobalInstance
      ) {
        this.$store.dispatch('saveActiveContainer');
      }

      this.setEditedItem(`${this.name}.${this.model.length - 1}`);
    },
  },
};
</script>

<style scoped lang="scss">
.ui-list {
  h3 {
    font-weight: $lb-medium;
    font-size: $size-small;
    line-height: 1.5;
    color: $dark;
  }

  .help-text {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: $size-smaller;
    line-height: 14px;
    color: #7f7f7f;
  }

  .btn {
    font-size: $size-small;
    position: relative;
    margin: 16px auto 0;

    &:disabled {
      pointer-events: unset;
    }

    .slb-tooltip {
      visibility: hidden;
      opacity: 0;
      margin-left: 0;
    }

    &:hover {
      .slb-tooltip {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }
    }
  }
}
</style>
